import { Component, OnInit } from '@angular/core';
import { SidenavService } from '../../services/sidenav.service';
import { select } from '@angular-redux/store';
import { Observable } from 'rxjs';
import { AdminState } from '../../../store/admin-store/admin-state.model';
import { MatTableDataSource } from '@angular/material';
import { MatButton } from '@angular/material/button';
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { NgFor } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

interface FlagObject {
  flag: string;
  value: string;
}

@Component({
    selector: 'app-show-flags',
    templateUrl: './show-flags.component.html',
    styleUrls: ['./show-flags.component.scss'],
    imports: [MatButton, MatTable, NgFor, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, TranslatePipe]
})
export class ShowFlagsComponent implements OnInit {
  /**
  * @Property DCMFlags to hold the dcm flags object
  **/
  public DCMFlags: any;
  /**
  * @Property HUFlags to hold the headunit flags object
  **/
  public HUFlags: any;
  /**
  *@arg  observe api variable in redux
  **/
  @select('admin') readonly adminObservable1: Observable<AdminState>;
  /**
   * @Property to hold the displayed columns
   **/
  public displayedColumns: string[];
  /**
  * @Property to hold the dcm flags data source array
  **/
  public dcmDataSource: MatTableDataSource<any>;
  /**
  * @Property to hold the headunit flags data source array
  **/
  public huDataSource: MatTableDataSource<any>;
  /**
  * @Property place holder for datasource array
  **/
  public dataSource: MatTableDataSource<any>;
  /**
  * @Property place holder for objects of type flagObject
  **/
  public flagObjectArray: Array<FlagObject>;

  constructor(
    private sidenav: SidenavService,
  ) {

    this.adminObservable1.subscribe((adminStore) => {
      this.DCMFlags = adminStore['otherParams']['dcm'];
      this.HUFlags = adminStore['otherParams']['headunit'];
    });
  }

  /**
   * @function ngOnInit sets initial configuration
   */
  ngOnInit(): void {
    this.displayedColumns = ['flag', 'value'];
    this.dcmDataSource = this.setDataSources(this.DCMFlags);
    this.huDataSource = this.setDataSources(this.HUFlags);
  }

  /**
  * @function setDataSources returns header translation upon recieving header column
  * @arg flagObject: object
  * @returns MatTableDataSource Array
  **/
  public setDataSources(flagObject): MatTableDataSource<any> {
    this.flagObjectArray = [];
    Object.entries(flagObject).forEach(([key, value]) => {
      const temp: FlagObject = {
        flag: key,
        value: (value as string).toUpperCase()
      };
      this.flagObjectArray.push(temp);
    });

    this.dataSource = new MatTableDataSource(this.flagObjectArray);

    return this.dataSource;
  }

  /**
  * @function getHeaderTranslation returns header translation upon recieving header column
  * @arg header: string
  * @returns headerTranslation
  **/
  public getHeaderTranslation(header: string): string {
    const headerTranslation = `provisioning.flags-sidenav.labels.${header}`;
    return headerTranslation;
  }

  /**
  * @function close closes the side nav when called
  **/
  public close(): void {
    this.sidenav.close();
  }

}
